import React from "react";

export default function IconArrow({ ...props }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.75 8.84749C0.75 8.30177 1.19772 7.85938 1.75 7.85938L15.75 7.85938C16.3023 7.85938 16.75 8.30177 16.75 8.8475C16.75 9.39322 16.3023 9.83562 15.75 9.83562L1.75 9.83561C1.19771 9.83561 0.75 9.39322 0.75 8.84749Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.04094 1.23082C8.43146 0.844935 9.06463 0.844935 9.45515 1.23082L16.4552 8.14765C16.8457 8.53353 16.8457 9.15918 16.4552 9.54506L9.45515 16.4619C9.06463 16.8478 8.43146 16.8478 8.04094 16.4619C7.65041 16.076 7.65041 15.4504 8.04094 15.0645L14.3338 8.84635L8.04094 2.62823C7.65042 2.24235 7.65042 1.6167 8.04094 1.23082Z"
        fill="#29394D"
      />
    </svg>
  );
}
